import { CommonError } from '../../types';
import { UserAssetsActions } from './actions';
import {
    FETCH_USER_ASSETS_FAILURE,
    FETCH_USER_ASSETS_REQUEST,
    FETCH_USER_ASSETS_SUCCESS,
    FETCH_USER_PNL_EXPECTED_FAILURE,
    FETCH_USER_PNL_EXPECTED_REQUEST,
    FETCH_USER_PNL_EXPECTED_SUCCESS,
    FETCH_USER_PNL_FAILURE,
    FETCH_USER_PNL_REQUEST,
    FETCH_USER_PNL_SUCCESS,
} from './constants';
import { UserAssetsData, UserPnLData, UserPnLExpectedData } from './types';
// import {  UserAssetsData } from './types';

export interface UserAssetsState {
    userAssetsData: UserAssetsData;
    userPnLData: UserPnLData;
    userPnLExpectedData: UserPnLExpectedData[];
    loading: boolean;
    error: CommonError | null;
    userPnLloading: boolean;
    userPnLExpectedloading: boolean;
}
const initialState = {
    loading: false,
    userAssetsData: {
        wallet: [],
        portfolios: [],
    } as UserAssetsData,
    error: null,
    userPnLData: { totalBuyValue: 0, totalSellValue: 0, profitLoss: 0, totalBuyVolume: 0, totalSellVolume: 0 },
    userPnLExpectedData: [],
    userPnLloading: false,
    userPnLExpectedloading: false,
};
export const UserAssetsReducer = (state = initialState, action: UserAssetsActions): UserAssetsState => {
    switch (action.type) {
        case FETCH_USER_ASSETS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_USER_ASSETS_SUCCESS: {
            return { ...state, loading: false, userAssetsData: action.payload };
        }
        case FETCH_USER_ASSETS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case FETCH_USER_PNL_REQUEST:
            return { ...state, userPnLloading: true, error: null };
        case FETCH_USER_PNL_SUCCESS: {
            return { ...state, userPnLloading: false, userPnLData: action.payload };
        }
        case FETCH_USER_PNL_FAILURE:
            return { ...state, userPnLloading: false, error: action.payload };
        case FETCH_USER_PNL_EXPECTED_REQUEST:
            return { ...state, userPnLloading: true, error: null };
        case FETCH_USER_PNL_EXPECTED_SUCCESS: {
            return { ...state, userPnLloading: false, userPnLExpectedData: action.payload };
        }
        case FETCH_USER_PNL_EXPECTED_FAILURE:
            return { ...state, userPnLloading: false, error: action.payload };
        default:
            return state;
    }
};
